import {
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ClientConfigClass;
function ClientConfig() {
  if (ClientConfigClass === VOID) {
    class $ {
      constructor(prereleaseMode, auth0ClientId, auth0Domain, basename, expressEnv, webpackPublicPath, websocketHost) {
        this.s7m_1 = prereleaseMode;
        this.t7m_1 = auth0ClientId;
        this.u7m_1 = auth0Domain;
        this.v7m_1 = basename;
        this.w7m_1 = expressEnv;
        this.x7m_1 = webpackPublicPath;
        this.y7m_1 = websocketHost;
      }
      toString() {
        return 'ClientConfig(prereleaseMode=' + this.s7m_1 + ', auth0ClientId=' + this.t7m_1 + ', auth0Domain=' + this.u7m_1 + ', basename=' + this.v7m_1 + ', expressEnv=' + this.w7m_1 + ', webpackPublicPath=' + this.x7m_1 + ', websocketHost=' + this.y7m_1 + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.s7m_1);
        result = imul(result, 31) + getStringHashCode(this.t7m_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.u7m_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.v7m_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.w7m_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.x7m_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.y7m_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientConfig()))
          return false;
        if (!(this.s7m_1 === other.s7m_1))
          return false;
        if (!(this.t7m_1 === other.t7m_1))
          return false;
        if (!(this.u7m_1 === other.u7m_1))
          return false;
        if (!(this.v7m_1 === other.v7m_1))
          return false;
        if (!(this.w7m_1 === other.w7m_1))
          return false;
        if (!(this.x7m_1 === other.x7m_1))
          return false;
        if (!(this.y7m_1 === other.y7m_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ClientConfig');
    ClientConfigClass = $;
  }
  return ClientConfigClass;
}
//region block: exports
export {
  ClientConfig as ClientConfig2mpft8d5d0hh3,
};
//endregion

//# sourceMappingURL=ClientConfig.mjs.map
